import { BaseAnalyticsApi } from './baseAnalyticsApi'
import type { IConversationsStatisticResponse, IConversationsChartResponse } from './types'

class ConversationsApi extends BaseAnalyticsApi<
  IConversationsStatisticResponse,
  IConversationsChartResponse
> {
  constructor() {
    super('conversations')
  }
}

export const ConversationsAnalyticsApi = new ConversationsApi()
